$(function(){
    window.$grid = $('.mgrid').masonry({
        // options
        itemSelector: '.grid-item',
        // columnWidth: 223,
        columnWidth: '.grid-sizer',
        percentPosition: true,
    });

    window.bindBoxZIndex();
});

window.bindBoxZIndex = function(){
    $('.mgrid .grid-item.grow').on({
        mouseenter: function () {
            $(this).css('z-index', 300);
        },
        mouseleave: function () {
            setTimeout(() => {
                $(this).css('z-index', 0);
            }, 50);
        }
    });
}

window.addEventListener('resize', function(event) {
    setTimeout(() => {
        window.$grid.masonry('layout');
        $('.hovered').removeClass('hovered');
    }, 300);
}, true);